import PropTypes from 'prop-types';
import { Component } from 'react';
import { timeDifference } from '../Helper/DateHelper';
import { getCommonTranslation } from '../../utils/TranslationHelper';
import Flux from '../../flux/Flux';
import FeedPostCommentMenu from './FeedPostCommentMenu';
import { generateKey } from '../../utils/CommonUtils';
import { postCommentType, REPLY_SIGN, getNewLineText } from './FeedHelper';

class FeedPostCommentTile extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showAllReplies: false,
		};

		this.inputRef = null;
	}

	findUserName(text) {
		let name = '';
		const namePart = text.split(' ')[0];
		if (this.props.comments.nodes) {
			this.props.comments.nodes.find((comment) =>
				comment.replies.find((reply) => {
					if (comment.comment.user && namePart === REPLY_SIGN + comment.comment.user.name) {
						name = comment.comment.user.name;
					} else if (namePart === REPLY_SIGN + reply.user.name) {
						name = reply.user.name;
					}
				}),
			);
		}
		return name;
	}

	getFormattedText(text, removeMention) {
		let newText = text;
		if (newText.startsWith(REPLY_SIGN)) {
			const name = this.findUserName(newText);
			if (removeMention) {
				newText = text.replace(REPLY_SIGN + name, '');
			} else if (name) {
				newText = text.replace(REPLY_SIGN + name, '<span class="feed-comments__hightlight">' + REPLY_SIGN + name + '</span>');
			}
			return newText;
		}
		newText = getNewLineText(newText);
		return newText;
	}

	getCommentTile(comment, allReplies, removeMention = false, index = 0) {
		const replies = allReplies && allReplies[0] ? (this.state.showAllReplies ? allReplies : [allReplies[0]]) : null;
		return (
			<div key={generateKey('feed-comment', index)} className="feed-comments-item__wrapper">
				<div className="feed-comments-item">
					<div className="feed-comments-image-wrapper">
						<img
							className="feed-comments-image"
							src={comment.user.avatar ? comment.user.avatar.url : 'https://www.visit-x.net/assets/img/navbar/guest_dummy.jpg'}
						></img>
					</div>
					<div className="feed-comments-item__text-container">
						<div className="feed-comments-item__text-name">
							{comment.user.name}
							{comment.tipped && <img className="feed-comments-item__text-icon" src="/assets/img/icons/coin.svg" />}
						</div>
						<div
							className="feed-comments-item__text"
							dangerouslySetInnerHTML={{ __html: this.getFormattedText(comment.text, removeMention) }}
						></div>
						<div className="feed-comments-item__info ">
							<span>{timeDifference(comment.created)}</span>
							{this.props.hasAvs && Flux.Guest.isLoggedIn() && this.props.showReplyText && (
								<span className="h-cursor-pointer" onClick={(e) => this.props.onClickReply(e, comment)}>
									{getCommonTranslation('reply')}
								</span>
							)}
							{Flux.Guest.isLoggedIn() && this.props.showReplyText && (
								<FeedPostCommentMenu comment={comment} postId={this.props.postId} />
							)}
						</div>
					</div>
				</div>
				{replies && replies.length > 0 && (
					<div className="feed-comments-item-reply">
						{replies.slice().map((reply, index) => this.getCommentTile(reply, null, reply.parentId === reply.conversationId, index))}
					</div>
				)}
				{allReplies && allReplies.length > 1 && (
					<div
						className="feed-comments-item-reply feed-comments-item__text feed-comments-item-reply-more"
						onClick={() => this.setState({ showAllReplies: !this.state.showAllReplies })}
					>
						<span></span>
						{this.state.showAllReplies ? getCommonTranslation('hide-answers') : getCommonTranslation('show-more-answers')}
					</div>
				)}
			</div>
		);
	}

	render() {
		return this.getCommentTile(this.props.comment, this.props.replies, false);
	}
}

FeedPostCommentTile.propTypes = {
	comments: PropTypes.shape(postCommentType),
	comment: PropTypes.object.isRequired,
	replySign: PropTypes.string,
	replies: PropTypes.array,
	onClickReply: PropTypes.func,
	showReplyText: PropTypes.bool,
	hasAvs: PropTypes.bool,
	postId: PropTypes.string,
};

FeedPostCommentTile.defaultProps = {
	replies: null,
	showReplyText: false,
	hasAvs: false,
	postId: '',
};

export default FeedPostCommentTile;
